module.exports = __webpack_public_path__ + "static/media/0344_Medium.295d52eb.jpg";